// @ts-nocheck
/* Populate RAQ Form Hidden Fields */

if (document.querySelector('.wd-dealer-detail-raq-form')) {
    const dealerEmailInput = document.getElementById("HiddenField-1");
    const dealerTitleInput = document.getElementById("HiddenField-2");
    const dealerCityInput = document.getElementById("HiddenField-3");
    const dealerStateInput = document.getElementById("HiddenField-4");
    const dealerContactInput = document.getElementById("HiddenField-5");
    const addressItem = document.querySelector('.dealer-address-item');
        
    dealerEmailInput.value = addressItem.dataset.email;
    dealerTitleInput.value = addressItem.dataset.title;
    dealerCityInput.value = addressItem.dataset.city;
    dealerStateInput.value = addressItem.dataset.state;
    dealerContactInput.value = addressItem.dataset.contact;
}